import Add from 'components/Icons/Add';
import { IconButton } from 'components/lib';
import InsertFilesModal, {
  InsertFilesOnSubmit,
} from 'components/modals/InsertFilesModal/InsertFilesModal';
import { List, Set } from 'immutable';
import React from 'react';
import { ModalState } from 'records/ModalState';
import { PageId } from 'records/Page';
import { ProjectDriveSelectedItem } from 'records/ProjectDriveSelectedItem';
import { StudioProjectFileData } from 'records/StudioProjectFile';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import { IntegrationsSelectedItem } from 'records/IntegrationsSelectedItem';

interface Props extends WithAppStoreProps {
  id: string;
  initialPages?: Set<PageId>;
  initialProjectDriveItems?: List<ProjectDriveSelectedItem>;
  initialIntegrationItems?: List<IntegrationsSelectedItem>;
  initialStudioItems?: List<StudioProjectFileData>;
  onSubmit: InsertFilesOnSubmit;
  className?: string;
  drawingsDisabled?: boolean;
  customLabel?: string;
}

const InsertFilesButton: React.FC<Props> = ({
  actions,
  id,
  initialPages,
  initialProjectDriveItems: initialProjectSelectedItems,
  initialIntegrationItems,
  initialStudioItems: initialStudioSelectedItems,
  onSubmit,
  className,
  drawingsDisabled,
  customLabel,
}) => {
  const openInsertFilesModal = (): void => {
    if (initialPages) {
      actions.setSelectedPages(initialPages);
    }
    if (initialProjectSelectedItems) {
      actions.setProjectDriveSelectedItems(initialProjectSelectedItems);
    }
    if (initialIntegrationItems) {
      actions.setIntegrationsSelectedItems(initialIntegrationItems);
    }
    if (initialStudioSelectedItems) {
      const defaultStudioFiles = initialStudioSelectedItems.toArray();
      actions.setStudioSelectedFiles(defaultStudioFiles);
    }

    const modalState = new ModalState({
      id: 'insertFilesModal',
      portal: 'main',
      open: true,
      component: InsertFilesModal,
      props: {
        onSubmit,
        drawingsDisabled,
      },
    });

    actions.createModal(modalState);
  };

  const { translate } = useTranslator(['buttons']);

  return (
    <IconButton
      id={id}
      variant="secondary"
      isLoading={false}
      size="small"
      onClick={openInsertFilesModal}
      className={`flex-center ${className}`}
    >
      <Add />
      {customLabel || translate('buttons:insertFiles')}
    </IconButton>
  );
};

export default withAppStore<Props>(InsertFilesButton);
